var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokerRev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AF77FF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.9,
    cy: 28.1,
    r: 0.9
  }))), /*#__PURE__*/React.createElement("path", {
    id: "wallet:1_00000010997339781779764040000010185606851111680148_",
    className: "st1",
    d: "M33.8,35H16.2c-0.6,0-1.2-0.5-1.2-1.2 V22.3c0-0.6,0.5-1.2,1.2-1.2h17.7c0.6,0,1.2,0.5,1.2,1.2v11.6C35,34.5,34.5,35,33.8,35z M32.9,34.1h0.9c0.1,0,0.3-0.1,0.3-0.3V22.3 c0-0.1-0.1-0.3-0.3-0.3h-0.9c0,0.1,0,0.2,0,0.3v4.3h-4.2c-0.8,0-1.4,0.6-1.4,1.4c0,0.4,0.2,0.7,0.4,1c0.3,0.3,0.6,0.4,1,0.4H33v4.3 C33,34,32.9,34.1,32.9,34.1z M16.2,22.1c-0.1,0-0.3,0.1-0.3,0.3V34c0,0.1,0.1,0.3,0.3,0.3h15.6c0.1,0,0.3-0.1,0.3-0.3v-3.4h-3.3 c-0.6,0-1.2-0.2-1.6-0.7c-0.4-0.4-0.7-1-0.7-1.7c0-1.3,1-2.3,2.3-2.3h3.3v-3.4c0-0.1-0.1-0.3-0.3-0.3H16.2V22.1z M35,30.4h-6.2 c-0.6,0-1.2-0.2-1.6-0.7c-0.4-0.4-0.7-1-0.7-1.7c0-1.3,1-2.3,2.3-2.3H35V30.4z M28.7,26.7c-0.8,0-1.4,0.6-1.4,1.4 c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4H34v-2.9h-5.3V26.7z M28.9,29c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9S28,27.6,28,28.1 S28.4,29,28.9,29z M29.9,30.1H29v-0.3h0.9V30.1z M28,30c-0.3-0.1-0.5-0.3-0.7-0.5l-0.1-0.1l0.2-0.2l0.1,0.1 c0.2,0.2,0.4,0.3,0.6,0.4L28,30z M26.8,28.6c0-0.2-0.1-0.3-0.1-0.5s0-0.3,0.1-0.5l0.3,0.1c0,0.1-0.1,0.3-0.1,0.4s0,0.3,0,0.4 L26.8,28.6z M27.5,26.9l-0.2-0.2c0.2-0.2,0.5-0.4,0.8-0.6l0.1,0.3C27.9,26.6,27.7,26.7,27.5,26.9z M29.9,26.4H29v-0.3h0.9V26.4z  M30.3,21.6L19,18.1l1-3.2L30.3,21.6z M19.7,17.7l6.6,2l-6-3.9L19.7,17.7z M31.8,21.8L17,21.6l1.1-4.3L31.8,21.8z M17.8,21L28,21.1 L18.6,18L17.8,21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.9,
    cy: 28.1,
    r: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.4,29.8 30.8,29.8 30.8,30.1 31.1,30.1 31.1,30.4 31.4,30.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 31.2,
    className: "st0",
    width: 0.3,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.4,32.8 31.1,32.8 31.1,33.1 30.8,33.1 30.8,33.4 31.4,33.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 33.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.2,33.1 16.9,33.1 16.9,32.8 16.6,32.8 16.6,33.4 17.2,33.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 31.1,
    className: "st0",
    width: 0.3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 29.4,
    className: "st0",
    width: 0.3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 27.7,
    className: "st0",
    width: 0.3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 25.9,
    className: "st0",
    width: 0.3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 24.2,
    className: "st0",
    width: 0.3,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.9,23 17.2,23 17.2,22.7 16.6,22.7 16.6,23.3 16.9,23.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 22.7,
    className: "st0",
    width: 0.9,
    height: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.4,22.7 30.8,22.7 30.8,23 31.1,23 31.1,23.3 31.4,23.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 24.1,
    className: "st0",
    width: 0.3,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.4,25.8 31.1,25.8 31.1,26.1 30.8,26.1 30.8,26.4 31.4,26.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29.8,
    className: "st0",
    width: 0.9,
    height: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,30c-0.3-0.1-0.5-0.3-0.7-0.5l-0.1-0.1l0.2-0.2l0.1,0.1c0.2,0.2,0.4,0.3,0.6,0.4L28,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.8,28.6c0-0.2-0.1-0.3-0.1-0.5s0-0.3,0.1-0.5l0.3,0.1c0,0.1-0.1,0.3-0.1,0.4s0,0.3,0,0.4L26.8,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,26.9l-0.2-0.2c0.2-0.2,0.5-0.4,0.8-0.6l0.1,0.3C27.9,26.6,27.7,26.7,27.5,26.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26.1,
    className: "st0",
    width: 0.9,
    height: 0.3
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerRev);
export default __webpack_public_path__ + "static/media/Broker_Rev.73c5e3383f2d9f540cb6a142a2a5de8e.svg";
export { ForwardRef as ReactComponent };